<template>
	<div id="workbench">
		<div class="main">
			<div class="Ltitle">
				<div class="Ltitle_pj">当前项目：{{ pjName || '暂无项目' }}</div>
				<div class="Ltitle_time">登录时间：{{ time }}</div>
			</div>
			<iframe ref="wjifname" class="main_iframe" :src="wjiframe"></iframe>
		</div>
		<div class="information">
			<div class="information_getpj">
				<div :disabled="projectId == null ? true : false" class="getpj_next" :style="BannedClick == true ? 'background-color: #0080ff;;' : 'background-color: #cccccc;'">
					<span class="next_explain">获取下一条样本</span>
					<div class="getpj_icon" @click="nextPj"><i class="nexticon el-icon-right"></i></div>
				</div>
				<div class="voluntarily" :style="voluntarilyClick == true ? 'background-color: #0080ff;' : 'background-color: #cc5151;'">
					<span class="next_explain">{{ voluntarilyText }}</span>
					<div class="getpj_icon" @click="voluntarilyNext"><i class="nexticon el-icon-right"></i></div>
				</div>
			</div>
			<div class="information_particulars">
				<div class="particulars_title">
					<div class="title_yb" @click="sample">
						<i class="icon dficonfont icon-weibiaoti-"></i>
						<span class="yb_text">样本信息</span>
					</div>
					<div class="title_lsjl" @click="examineHistory" title="历史记录"><i class="icon dficonfont icon-lishijilu-copy"></i></div>
				</div>
				<!-- <el-button @click="tClick">临时</el-button> -->
				<div class="particulars_tableBox">
					<table v-if="sampleorhistory == true" class="particulars_table" border="1" cellspacing="0" cellpadding="0">
						<tr class="Ptable_title">
							<th class="Ptable_title_field">字段</th>
							<th>
								值
								<i class="el-icon-edit xg" title="修改" @click="xg" v-if="alert_sample == 1"></i>
							</th>
						</tr>
						<tr class="Ptable_content" v-for="(item, index) in sampleData.slice(0, sampleNumber)" :key="index">
							<td class="Ptable_content_value">{{ item.fieldKey }}</td>
							<td class="Ptable_content_value">{{ item.fieldValue }}</td>
						</tr>
					</table>
				</div>

				<div v-if="sampleorhistory == true" class="particulars_btn" @click="an">
					{{ sampletext }}
					<i :class="sampleicon"></i>
				</div>
				<div v-if="sampleorhistory == false && historyData.length != 0" class="history">
					<div class="HistoricalRanking" v-for="(item, index) in historyData" :key="index">
						<div class="yuanjiao" v-if="index < 11">
							<span class="yuanjiaotext">{{ index + 1 }}</span>
						</div>
						<p class="historyTime">{{ formatDate(item.createtime) }}--{{ formatDate(item.endTime) }}</p>
						<p class="historyName">访问人员 : {{ item.u_NickName }}</p>
						<p class="historyStatus">状态 : {{ item.typeName }}</p>
					</div>
				</div>
				<div style="text-align: center; line-height: 100px" v-if="sampleorhistory == false && historyData.length == 0">暂无拨打记录</div>
			</div>
			<div class="phoneBtn" v-if="PhoneBtnshow">
				<el-button type="warning" @click="sendBack">放回</el-button>
				<el-button type="warning" @click="refusalvisit">拒访</el-button>
				<el-button type="warning" @click="noAnswer">无人接听</el-button>
				<el-button type="primary" @click="later">稍后</el-button>
			</div>
			<div class="information_phone">
				<div class="phone_dial" v-if="dialing == true">
					<span class="phone_text" ref="callphone" :contenteditable="importability" @keydown="textareaKeydown($event)">{{ phone }}</span>
					<span class="phone_icon" @click="phoneCall"><i class="icon dficonfont icon-dianhua"></i></span>
				</div>
				<div class="phone_hangUp" v-if="dialing == false">
					<span class="phone_text">{{ phone }}</span>
					<!-- 挂机 -->
					<span class="phone_icon" @click="hangUp"><i class="icon dficonfont icon-guaduan"></i></span>
				</div>
				<div class="phone_extension" v-if="ext == true">
					<span class="phone_text" ref="callext" :contenteditable="importability" @keydown="textareaKeydown($event)">{{ extPhone }}</span>
					<span class="phone_icon" @click="extCall"><i class="icon dficonfont icon-dianhua"></i></span>
				</div>
				<div class="phone_dialExtension" v-if="ext == false">
					<span class="phone_text">666</span>
					<span class="phone_icon"><i class="icon dficonfont icon-dianhua"></i></span>
				</div>
			</div>
		</div>
		<phoneStatus ref="phoneStatus" @ok="setstatusOk"></phoneStatus>
		<modificationSample ref="modificationSample" @ok="sampleOk"></modificationSample>
	</div>
</template>

<script>
import phoneStatus from '../components/phoneStatus.vue';
import modificationSample from '../components/modificationSample.vue';
import dial from '../components/dial'

import Vue from 'vue';
export default {
	components: {
		phoneStatus,
		modificationSample
	},
	data() {
		return {
			conceal: true, //******
			voluntarilyClick: true, //
			voluntarilyText: '自动拨号', //自动
			PhoneBtnshow: false, //放回稍后状态
			extPhone: '', //分机
			phone: '', //手机号
			interviewId: null, //打电话ID
			sampleDataList: {}, //样本信息
			BannedClick: true, //禁止点击
			time: '', //登陆时间
			pjName: '', //项目名称
			ext: true, //分机号
			dialing: true, //拨号挂断
			wjiframe: '/papersurveydf/dfindex.html', //问卷路径
			historyData: [], //历史列表
			sampleorhistory: true,
			sampleicon: 'icon dficonfont icon-zhankai',
			sampletext: '展开',
			sampleNumber: 4,
			sampleData: [], //数组数据
			projectId: '',
			sampleCode: '',
			forbid_up_phone: '', //禁止修改拨打电话
			hide_phone: '', //隐藏电话
			importability: true, //可输入
			alert_sample: '', //修改电话
			taskId: '', // 呼叫任务编号
			dialingType: '', // 管理端配置的拨号类型
		};
	},
	computed: {
		prCode() {
			return this.$store.state.pr_Code;
		},
		spCode() {
			return this.$store.state.s_Code;
		},
		prName() {
			return this.$store.state.projectinfo.pr_Name;
		},
		forbidUpPhone() {
			return this.$store.state.forbid_up_phone;
		},
		hidePhone() {
			return this.$store.state.hide_phone;
		},
		alertSample() {
			return this.$store.state.alert_sample;
		},
		dialInfo() {
			let data = window.localStorage.getItem('DialInfo') || ""
			return JSON.parse(data)
		}
	},
	watch: {
		prCode(newId, oldId) {
			if (newId) {
				this.projectId = newId;
				this.removerobj();
			}
		},
		spCode(newId, oldId) {
			if (newId) {
				this.sampleCode = newId;
			}
		},
		prName(newId, oldId) {
			if (newId) {
				this.pjName = newId;
			}
		},
		forbidUpPhone(newId, oldId) {
			if (newId) {
				this.forbid_up_phone = newId;
			}
		},
		hidePhone(newId, oldId) {
			if (newId) {
				this.hide_phone = newId;
			}
		},
		alertSample(newId, oldId) {
			if (newId) {
				this.alert_sample = newId;
			}
		}
	},
	// 组件内导航钩子，处理未保存退出的情况
	beforeRouteLeave: function(to, from, next) {
		if (this.BannedClick == false) {
			next(false);
			this.$message.warning('您有未处理完成的样本信息,请处理后在进行操作!');
		} else {
			next();
		}
	},
	//离开新增页、编辑页记得解绑，否则其他页面中也会出现提示的效果
	beforeDestroy() {
		window.removeEventListener('beforeunload', this.actBeforeUnload, false);
		// this.$refs.callphone.innerText = ''
	},
	created() {
		dialcontroller.workbench = this;
		window.addEventListener('beforeunload', this.actBeforeUnload, false);
		if (window.localStorage.getItem('userInfo') == null) {
			this.$router.push({ path: '/login' });
			return false;
		}
		this.time = JSON.parse(window.localStorage.getItem('userInfo')).logtime;
		this.projectId = this.$store.state.pr_Code == '' ? window.localStorage.getItem('prCode') : this.$store.state.pr_Code;
		this.sampleCode = this.$store.state.s_Code == '' ? window.localStorage.getItem('sCode') : this.$store.state.s_Code;
		// debugger;
		if (typeof this.$store.state.projectinfo.pr_Name == 'undefined') {
			if (JSON.parse(window.localStorage.getItem('projectinfo')) == null) {
				this.pjName = '暂无项目';
			} else {
				this.pjName = JSON.parse(window.localStorage.getItem('projectinfo')).pr_Name;
			}
		} else {
			this.pjName = this.$store.state.projectinfo.pr_Name;
		}
		console.log(this.pjName);
		/** 修改扩展信息 */
		let alert_sample = this.$store.state.alert_sample == '' ? window.localStorage.getItem('alert_sample') : this.$store.state.alert_sample;
		if (alert_sample == null) {
			this.alert_sample = 0;
		} else {
			this.alert_sample = alert_sample;
		}
		/** 禁止修改拨打电话 */
		let forbid_up_phone = this.$store.state.forbid_up_phone == '' ? window.localStorage.getItem('forbid_up_phone') : this.$store.state.forbid_up_phone;
		if (forbid_up_phone == null) {
			this.forbid_up_phone = 0;
		} else {
			this.forbid_up_phone = forbid_up_phone;
		}
		/** 隐藏电话 */
		let hide_phone = this.$store.state.hide_phone == '' ? window.localStorage.getItem('hide_phone') : this.$store.state.hide_phone;
		if (hide_phone == null) {
			this.hide_phone = 0;
		} else {
			this.hide_phone = hide_phone;
		}
		// 路由跳转
		if (typeof this.$route.query.dialtype != undefined) {
			//约访回拨
			if (this.$route.query.dialtype == 'yf') {
				let yhphone = this.$route.query.phone;
				let yhareaCode = this.$route.query.areaCode;
				let yhextensionNumber = this.$route.query.extensionNumber;
				let that = this;
				this.yfReadSample(this.$route.query.scode, this.$route.query.pindex, function() {
					// debugger;
					that.phone = yhareaCode + yhphone == '' ? that.phone : yhareaCode + yhphone;
					that.$refs.callphone.innerText = yhareaCode + yhphone == '' ? that.phone : yhareaCode + yhphone;
					that.extPhone = yhextensionNumber;
					that.PhoneBtnshow = true;
				});
			}
			if (this.$route.query.dialtype == 'sh') {
				//稍后
				let yhphone = this.$route.query.phone;
				let yhareaCode = this.$route.query.areaCode;
				let that = this;
				that.PhoneBtnshow = true;
				this.shReadSample(this.$route.query.scode, 1, function() {
					// debugger;
					that.phone = yhareaCode + yhphone == '' ? that.phone : yhareaCode + yhphone;
					that.$refs.callphone.innerText = yhareaCode + yhphone == '' ? that.phone : yhareaCode + yhphone;
					that.PhoneBtnshow = true;
				});
			}
		}
	},
	methods: {
		//监听按键操作
		textareaKeydown(event) {
			console.log(event.keyCode);
			if (event.keyCode === 13 || event.keyCode === 32) {
				//空格  //回车
				event.preventDefault(); // 阻止浏览器默认换行操作
				return false;
			}
		},

		hqExtCheckIn(proid) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.hqExtCheckIn}`,
				data: {
					proid: proid //项目id
				},
				cb(res) {
					if (res.result == '111111111111') {
						console.log(res);
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		removerobj() {
			this.sampleData = [];
			this.extPhone = '';
			this.phone = '';
			this.historyData = [];
			this.wjiframe = '/papersurveydf/dfindex.html';
		},
		setpreReadSample(scode, pindex) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.preReadSample}`,
				data: {
					prCode: this.projectId, //项目id
					sampleCode: scode //样本id
				},
				cb(res) {
					if (res.result == '111111111111') {
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		sampleOk() {},
		xg() {
			this.$refs.modificationSample.sampleData = this.sampleDataList.extendedFieldList;
			this.$refs.modificationSample.openSample();
			// console.log(this.sampleDataList.extendedFieldList)
		},
		// 改变样本状态
		setSamplestatus(scode, pindex) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.updatesampleInterview}`,
				data: {
					prCode: this.projectId, //项目id
					sampleCode: scode, //样本id
					interviewId: pindex
				},
				cb(res) {
					if (res.result == '111111111111') {
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		sethidePhone() {
			if (this.hide_phone == 0) {
				this.conceal = true;
			} else {
				this.conceal = false;
			}
		},
		// 判断项目是否可拨打电话
		setimportability() {
			if (this.forbid_up_phone == 0) {
				this.importability = true;
			} else {
				this.importability = false;
			}
		},
		// tClick() {
		// 	dialcontroller.workbench.preReadSample(10);
		// },
		//自动拨号
		voluntarilyNext() {
			if (!this.BannedClick) {
				this.$message.warning('请先处理完当前样本,再进行外呼!');
				return false;
			}
			if (this.voluntarilyClick) {
				this.voluntarilyText = '停止自动拨号';
				this.voluntarilyClick = false;
				dialcontroller.agentReady();
			} else {
				this.voluntarilyText = '自动拨号';
				this.voluntarilyClick = true;
				dialcontroller.agentNotReady(2);
			}
		},
		// 稍后
		later() {
			samplesatate = 9;
			this.phoneOk();
			this.PhoneBtnshow = false;
			this.removerobj();
		},
		//放回
		sendBack() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.putItBackOneSample}`,
				data: {
					prCode: this.projectId, //项目id
					sampleCode: this.sampleCode //样本id
				},
				cb(res) {
					if (res.result == '111111111111') {
						
						samplesatate = 1;
						that.$message.success(res.msg);
						that.phoneOk();
						// that.resetStatus();
						that.removerobj();
						
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
			this.PhoneBtnshow = false;
			console.warn('this.PhoneBtnshow :>> ', this.PhoneBtnshow);
		},
		// 拒访
		refusalvisit() {
			interviewstate = 7;
			samplesatate = 7;
			this.updateInterviewLog();
			// this.sendBack();
			this.PhoneBtnshow = false;
			this.removerobj();
			this.resetStatus();
		},
		// 无人接听
		noAnswer () {
			interviewstate = 4;
			samplesatate = 1;
			this.updateInterviewLog();
			this.PhoneBtnshow = false;
			this.removerobj();
			this.resetStatus();
		},
		// 插入样本约访记录
		appointment(item, pindex) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.addSamplePromissoryInterview}`,
				data: {
					prCode: this.projectId, //项目id
					sCode: this.sampleCode, //样本id
					intermitPage: pindex, // 中断页码
					areaCode: item.zone, //区号
					extensionNumber: item.Ext, //分机号
					phone: item.phone, //预约拨打手机号
					remarks: item.phoneRemark, //备注
					dateTime: item.tiemDate //预约拨打时间
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.$message.success(res.msg);
						that.$refs.phoneStatus.psVisible = false;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		//选择状态成功
		setstatusOk(value) {
			interviewstate = value.is_Id;
			samplesatate = value.ssId;
			if (interviewstate == 2) {
				// console.log(this.$refs.wjifname)
				let framework = this.$refs.wjifname;
				var pindex = 1;
				if (framework.contentWindow.SavePaper) {
					pindex = framework.contentWindow.SavePaper(samplesatate);
					//alert("问卷已经保存，页面为"+pindex);
				} else {
					//alert("没有打开问卷答题界面，无需保存问卷！");
				}
				this.appointment(value.phoneObj, pindex);
			}
			//更新访问记录
			this.updateInterviewLog();

			if (value.ssId != 0) {
				console.log('1 :>> ', 1);
				if (value.ssId != 1) {
				console.log('2 :>> ', 2);
					this.phoneOk();
				} else {
					this.sendBack();
				console.log('3 :>> ', 3);
				}
			} else {
				this.PhoneBtnshow = true;
			}

			console.log(value);
		},
		// 挂机保存电话状态
		phoneOk() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.verifyQuota}`,
				data: {
					ssId: samplesatate, //样本状态
					prcode: this.projectId, // 项目编号
					sampleId: this.sampleCode // 样本Id
				},
				cb(res) {
					if (res.result == '111111111111') {
						// that.$message.success(res.msg);
						that.resetStatus();
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},

		// 分机打电话
		extCall() {
			this.extPhone = this.$refs.callext.innerText;
			var dialresult = dialcontroller.DialExt(this.extPhone);
			if (!dialresult) {
				alert('分机拨号失败，请重试！');
			}
		},
		//更新访问记录
		updateInterviewLog() {
			let data = this.getUpdateInterviewLogData()
			let that = this
			let params = {
				that: this,
				method: 'POST',
				url: this.dialInfo.dialtype == 4 ? this.$config.service.updatesampleInterviewstatusBycondition : this.$config.service.updatesampleInterviewstatus,
				data: data,
				cb(res) {
					if (res.result == '111111111111') {
						console.log('挂断电话', res.data);
						that.$refs.phoneStatus.psVisible = false;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		getUpdateInterviewLogData() {
			let data = {
				prCode: this.projectId,
				sampleCode: this.sampleCode,
				interviewId: this.interviewId,
				status: samplesatate,
				type: interviewstate,
			}
			if(this.dialInfo.dialtype == 4) {
				// 华旗国产化
				data = {...data, 
					callid: this.taskId,
					DSS_ID: this.dialInfo.dstid,
				}
				return data
			} else{
				let recordFile = dialcontroller.reacrdPath;
				let tempcallid = dialcontroller.callid;
				let tempdstid =  dialcontroller.entity.dstid
				dialcontroller.isupdateinterviewstate = false
				console.log('录音控件', recordFile);
				if (recordFile == undefined) {
					recordFile = '';
				}
				data = {...data, 
					callid: tempcallid,
					recordFile: recordFile,
					DSS_ID:tempdstid,
					extensionNumber: this.sampleDataList.Pi_Ext,
				}
				return data
			}
		},
		// 挂断电话
		hangUp() {
			let framework = this.$refs.wjifname;
			if (framework.contentWindow.isLastPage) {
				if (framework.contentWindow.isLastPage()) {
					//打开问卷并且是最后一页
					this.$alert('检测到问卷已经到最后一页未提交,若该样本为有效答卷,请先"提交"问卷完成后再进行挂机操作,否则问卷结果可能会丢失.', {
						confirmButtonText: '继续答卷',
						cancelButtonText: '强制挂机',
						showCancelButton: true,
						callback: action => {
							if (action == 'confirm') {
							} else {
								this.hangUpExec();
							}
						}
					});
				} else {
					this.hangUpExec();
				}
			} else {
				this.hangUpExec();
			}
		},
		hangUpExec() {
			if (this.dialingType != '测试') {
				console.log('录音控件', dialcontroller.reacrdPath);
				if (isTalking) {
					var dialresult = dialcontroller.HangUp();
				}
				console.log('录音控件', dialcontroller.reacrdPath);
			}
			isTalking = false;
			this.setResult();
			this.dialing = true;
			// 国产拨号挂断
			if (this.dialInfo.dialtype == 4) {
				this.huaQiDropCall()
			}
		},
		// 国产拨号挂断
		huaQiDropCall() {
			try{
				let data = {
					taskId: this.taskId,
					targetUrl: this.dialInfo.APIServer
				}
				let params = {
					that: this,
					method: 'POST',
					url: `${this.$config.service.huaQiDropCall}`,
					headers: { 
						"Content-Type": 'application/json;charset=UTF-8',
					},
					data: data,
					cb(res) {
					}
				};
				this.$util.requestraw(params);
			}catch (e) {
				console.log('e :>> ', e);
			}
		},
		resetStatus() {
			//重设后可获取到下一条样本
			// 恢复可读取下一条样本
			this.BannedClick = true;
			//问卷是否正常完成
			paperisfinish = false;
			// 完成状态
			interviewstate = 1;
		},
		setResult() {
			if (paperisfinish) {
				//问卷正常完成
				this.phoneOk();
				//更新访问记录
				this.updateInterviewLog();
			} else {
				this.$refs.phoneStatus.phoneObj.zone = this.sampleDataList.Pi_AreaCode;
				// this.$refs.phoneStatus.phoneObj.phone = this.sampleDataList.S_Tel;
				this.$refs.phoneStatus.phoneObj.Ext = this.sampleDataList.Pi_Ext;
				this.$refs.phoneStatus.openPhoneSt();
			}
		},
		// 插入访问记录
		insetInterviewLog(phoneValue) {
			let that = this;
			let data = {
				prCode: this.projectId,
				sampleCode: this.sampleCode,
				phone: phoneValue,
				dialType: this.dialInfo.dialtype
			}
			if (this.dialInfo.dialtype == 4) {
				console.log('this.taskId :>> ', this.taskId);
				data.callid = this.taskId
				data.extensionNumber = this.dialInfo.clientid
			}
			let params = {
				that: this,
				method: 'POST',
				url: `${this.dialInfo.dialtype == 4 ? this.$config.service.createSampleInterviewlog : this.$config.service.addSampleInterviewlog}`,
				data: data,
				cb(res) {
					if (res.result == '111111111111') {
						console.log('打电话', res.data);
						that.interviewId = res.data;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		// 打电话
		phoneCall() {
			if (this.BannedClick) {
				this.$message.warning('该样本已处理完成,请重新获取样本!');
				return false;
			}
			

			// console.log(this.sampleDataList.S_Tel);
			let phone = this.hide_phone == 0 ? this.$refs.callphone.innerText : this.sampleDataList.Pi_AreaCode + this.sampleDataList.S_Tel;
			var dialinfo = {};
			dialinfo.Phone = phone;
			dialinfo.PrCode = this.projectId;
			dialinfo.SCode = this.sampleCode;
			console.log(dialinfo.Phone);
			if (dialinfo.Phone == '') {
				this.$message.warning('手机号不能为空！');
				return false;
			}
			console.log('this.dialInfo.dialtype :>> ', this.dialInfo.dialtype);
			if (this.dialInfo.dialtype == 4) {
				// 华旗国产化
				this.domesticDial(phone)
			} else{
				// 手机号拨号
				// dial.Dial(dialinfo.Phone)
				var dialresult = dialcontroller.Dial(dialinfo);
				console.log(dialresult);
			 

				if (!dialresult) {
					alert('拨号失败，请重试！');
				}else{
					// isTalking = true;
					this.PhoneBtnshow = false;
					this.insetInterviewLog(phone); //插入访问记录
					this.dialing = !dialresult;
				}
				if (dialresult == '测试') {
					this.dialingType = '测试'
					isTalking = true;
					this.$message.success('测试拨号成功！');
				}
			}
		},
		// 国产化拨号
		domesticDial (phone) {
			let that = this;
			let data = {
				callToken: "PR-001",
				sampleCode: this.sampleCode,
				callerId: phone,
				callerNumber: this.dialInfo.clientid,
				phone: phone,
				targetUrl: this.dialInfo.APIServer,
				prCode: this.projectId,
				callbackUrl: this.dialInfo.def5,
				recordStorePath: this.dialInfo.def1,
				recordPlayPath: this.dialInfo.def2,
			}
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.huaQiNewTask}`,
				headers: { 
					"Content-Type": 'application/json;charset=UTF-8',
				},
				data: data,
				cb(res) {
					if (res.code == 0) {
						// isTalking = true; // 拨号成功
						that.PhoneBtnshow = false; //放回稍后状态
						that.dialing = false; // 电话icon 变为红色挂断
						that.taskId = res.businessResult.taskId
						console.log('that.taskId :>> ', that.taskId);
						that.insetInterviewLog(phone); //插入访问记录
					} else {
						alert('拨号失败，请重试！');
					}
				}
			};
			this.$util.requestraw(params);
		},
		// 切换样本
		sample() {
			this.sampleorhistory = true;
		},
		// 历史记录
		examineHistory() {
			if (this.projectId == '' || this.projectId == null) {
				return false;
			}
			this.historyData = [];
			this.sampleorhistory = false;
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryOneSampleInterviewlog}`,
				data: {
					sampleCode: this.sampleCode,
					prCode: this.projectId
				},
				cb(res) {
					if (res.result == '111111111111') {
						console.log(res.data);
						that.historyData = res.data;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		// 样本名称配对样本数据
		matching(data) {
			console.log(data);
			let tempData = [
				{
					fieldKey: '样本编号',
					fieldValue: ''
				},
				{
					fieldKey: '电话区号',
					fieldValue: ''
				},
				{
					fieldKey: '电话号码',
					fieldValue: ''
				},
				{
					fieldKey: '电话分机',
					fieldValue: ''
				}
			];
			tempData.forEach(item => {
				if (item.fieldKey == '样本编号') {
					item.fieldValue = data.S_Code;
				} else if (item.fieldKey == '电话分机') {
					item.fieldValue = data.Pi_Ext;
				} else if (item.fieldKey == '电话区号') {
					item.fieldValue = data.Pi_AreaCode;
				} else if (item.fieldKey == '电话号码') {
					item.fieldValue = this.hide_phone == 0 ? data.S_Tel : '*******';
				}
			});
			console.log('--------', data.extendedFieldList[0].fieldValue);
			this.sampleData = [...tempData, ...data.extendedFieldList];
		},
		// 恢复
		recoverStatus() {
			//问卷是否正常完成
			paperisfinish = false;
			// 完成状态
			interviewstate = 1;
			// 样本状态
			samplesatate = 2;
		},
		// 获取下一条数据
		nextPj() {
			this.setimportability(); //是否禁止修改拨打电话
			if (!this.BannedClick) {
				this.$message.error('当前样本未完成!');
				return false;
			}
			if (!this.voluntarilyClick) {
				this.$message.error('请先停止自动外呼,才能获取样本');
				return false;
			}
			this.recoverStatus(); //// 恢复样本状态
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.extractOneSample}`,
				data: {
					prCode: this.projectId
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.$message.success(res.msg);
						that.$store.state.s_Code = res.data.s_Code;
						that.sampleCode = res.data.s_Code;
						window.localStorage.setItem('sCode', res.data.s_Code);
						that.$store.state.pindex = 1;
						that.setSampleMessage(); //获取样本信息
						that.loadpaper(); //加载问卷
						that.BannedClick = false;
						that.PhoneBtnshow = true;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},

		//预拨号获取
		preReadSample(scode) {
			this.BannedClick = false;
			this.voluntarilyClick = true;
			this.voluntarilyText = '自动拨号';
			this.dialing = false;
			// isTalking = true;
			paperisfinish = false;
			interviewstate = 1;

			this.$message.success('预拨成功!');
			this.$store.state.s_Code = scode;
			this.sampleCode = scode;
			window.localStorage.setItem('sCode', scode);
			this.$store.state.pindex = 1;
			let that = this;
			this.setSampleMessage(function() {
				//插入访问记录
				that.insetInterviewLog(that.phone);

				that.setpreReadSample(scode);
			}); //获取样本信息

			this.loadpaper(); //加载问卷
		},
		//约访号获取
		yfReadSample(scode, pindex, success) {
			this.BannedClick = false;
			this.voluntarilyClick = true;
			this.voluntarilyText = '自动拨号';
			paperisfinish = false;
			interviewstate = 1;

			this.$message.success('约访回拨成功!');
			this.$store.state.s_Code = scode;

			this.sampleCode = scode;
			window.localStorage.setItem('sCode', scode);
			this.$store.state.pindex = pindex;
			this.setSamplestatus(scode, pindex); //更新样本状态
			this.setSampleMessage(success); //获取样本信息
			this.loadpaper(); //加载问卷
		},

		//稍后号获取
		shReadSample(scode, pindex, success) {
			this.BannedClick = false;
			this.voluntarilyClick = true;
			this.voluntarilyText = '自动拨号';
			paperisfinish = false;
			interviewstate = 1;

			this.$message.success('稍后成功!');
			this.$store.state.s_Code = scode;

			this.sampleCode = scode;
			window.localStorage.setItem('sCode', scode);
			this.$store.state.pindex = 1;
			this.setSamplestatus(scode, pindex); //更新样本状态
			this.setSampleMessage(); //获取样本信息
			this.loadpaper(); //加载问卷
		},
		loadpaper() {
			if (this.$store.state.pr_Code != '' && this.$store.state.s_Code) {
				this.wjiframe = `/papersurveydf/welcome.html?prcode=${this.$store.state.pr_Code}&scode=${this.$store.state.s_Code}&pindex=${this.$store.state.pindex} `;
			}
			// console.log(this.wjiframe);
		},
		// 获取样本信息
		setSampleMessage(success) {
			if (this.projectId == '' || this.projectId == null) {
				this.$message.error('请先选择项目');
				return false;
			}
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryOneSample}`,
				data: {
					prCode: this.projectId,
					sampleCode: this.sampleCode
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.sampleDataList = res.data;
						if (!res.data.Pi_AreaCode) {
							res.data.Pi_AreaCode = '';
						}
						that.phone = that.hide_phone == 0 ? res.data.Pi_AreaCode + res.data.S_Tel : '*******'; //手机号
						that.$refs.callphone.innerText = that.hide_phone == 0 ? res.data.Pi_AreaCode + res.data.S_Tel : '*******'; //手机号
						if (!res.data.Pi_Ext) {
							res.data.Pi_Ext = '';
						}
						that.extPhone = res.data.Pi_Ext; //分机
						that.matching(res.data);

						if (success) {
							success();
						}

						// that.SampleMessageData = res.data
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},

		// 展开折叠
		an() {
			if (this.sampleNumber < this.sampleData.length) {
				this.sampleNumber = this.sampleData.length;
				this.sampletext = '折叠';
				this.sampleicon = 'icon dficonfont icon-zhankai spicon';
			} else {
				this.sampleNumber = 4;
				this.sampletext = '展开';
				this.sampleicon = 'icon dficonfont icon-zhankai';
			}
		},
		// 时间过滤器
		formatDate(value) {
			if (value == null) {
				return '';
			}
			let date = new Date(value.time);
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM;
			let d = date.getDate();
			d = d < 10 ? '0' + d : d;
			let h = date.getHours();
			h = h < 10 ? '0' + h : h;
			let m = date.getMinutes();
			m = m < 10 ? '0' + m : m;
			let s = date.getSeconds();
			s = s < 10 ? '0' + s : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		},
		actBeforeUnload(event) {
			if (this.BannedClick == false) {
				event.returnValue = '您有未处理完成的样本信息,请处理后在进行操作!';
			}
		}
	}
}
</script>

<style scoped="scoped" lang="scss">
#workbench {
	width: 100%;
	height: 100%;
	display: flex;
	.main {
		height: 100%;
		background-color: #ffffff;
		flex: 1;
		.Ltitle {
			height: 70px;
			display: flex;
			justify-content: space-between;
			background-color: #f6f9fd;
			.Ltitle_pj {
				line-height: 60px;
				font-size: 16px;
				color: #333333;
			}
			.Ltitle_time {
				line-height: 60px;
				font-size: 14px;
				color: #333333;
			}
		}
		.main_iframe {
			width: 100%;
			height: calc(100% - 60px);
			border: 0px;
		}
	}
	.information {
		width: 400px;
		height: 100%;
		background-color: #ffffff;
		margin-left: 30px;
		.information_getpj {
			height: 70px;
			background-color: #f6f9fd;
			position: relative;
			.getpj_next {
				width: 180px;
				height: 44px;
				background-color: #0080ff;
				border-radius: 22px;
				text-align: center;
				line-height: 44px;
				font-size: 16px;
				color: #ffffff;
				position: absolute;
				left: 0%;
				top: 50%;
				margin-top: -22px;
				.next_explain {
					position: absolute;
					left: 20px;
				}
				.getpj_icon {
					position: absolute;
					right: 4px;
					top: 4px;
					width: 36px;
					height: 36px;
					background-color: #0263c3;
					border-radius: 50%;
					cursor: pointer;
					.nexticon {
						text-align: center;
						position: absolute;
						right: 10px;
						top: 10px;
						font-size: 14px;
						color: #ffffff;
					}
				}
			}
			.voluntarily {
				width: 180px;
				height: 44px;
				background-color: #0080ff;
				border-radius: 22px;
				text-align: center;
				line-height: 44px;
				font-size: 16px;
				color: #ffffff;
				position: absolute;
				right: 0%;
				top: 50%;
				margin-top: -22px;
				.next_explain {
					position: absolute;
					left: 20px;
				}
				.getpj_icon {
					position: absolute;
					right: 4px;
					top: 4px;
					width: 36px;
					height: 36px;
					background-color: #0263c3;
					border-radius: 50%;
					cursor: pointer;
					.nexticon {
						text-align: center;
						position: absolute;
						right: 10px;
						top: 10px;
						font-size: 14px;
						color: #ffffff;
					}
				}
			}
		}
		.information_particulars {
			padding: 26px 20px 0px 20px;
			.particulars_title {
				// width: 340px;
				height: 20px;
				display: flex;
				justify-content: space-between;
				.title_yb {
					cursor: pointer;
					.icon-weibiaoti- {
						color: #0080ff;
					}
					.yb_text {
						margin-left: 10px;
						font-size: 14px;
						color: #333333;
					}
				}
				.title_lsjl {
					cursor: pointer;
				}
			}
			.particulars_tableBox {
				max-height: 500px;
				overflow: auto;
				.particulars_table {
					width: 100%;
					margin-top: 29px;
					border: 1px solid #abdcff;
					.Ptable_title {
						height: 36px;
						.Ptable_title_field {
							width: 160px;
						}
						.xg {
							width: 20px;
							height: 20px;
							float: right;
							margin-right: 20px;
						}
					}
					.Ptable_content {
						height: 36px;
						.Ptable_content_value {
							padding-left: 10px;
							font-size: 14px;
							color: #333333;
						}
					}
				}
			}
			.history {
				width: 100%;
				height: 500px;
				// max-height: 500px;
				overflow-y: auto;
				.HistoricalRanking {
					width: 340px;
					height: 110px;
					background-color: #ffffff;
					border-radius: 2px;
					border: solid 1px #e1e1e1;
					margin: 20px auto;
					position: relative;
					.yuanjiao {
						position: absolute;
						top: 0px;
						left: 0px;
						width: 30px;
						height: 30px;
						background-color: #ed7d39;
						border-radius: 2px 2px 28px 2px;
						.yuanjiaotext {
							line-height: 26px;
							color: #ffffff;
							font-size: 18px;
							margin-left: 7px;
						}
					}
					.historyTime {
						margin-top: 15px;
						margin-left: 34px;
						font-size: 14px;
						color: #333333;
					}
					.historyName {
						margin-top: 10px;
						margin-left: 34px;
						font-size: 14px;
						color: #333333;
					}
					.historyStatus {
						margin-top: 10px;
						margin-left: 34px;
						font-size: 14px;
						color: #333333;
					}
				}
			}
			.particulars_btn {
				font-size: 14px;
				color: #0080ff;
				margin-top: 23px;
				text-align: center;
				cursor: pointer;
				.spicon {
					transform: rotate(-180deg);
					display: inline-block;
				}
			}
		}
		.phoneBtn {
			width: 400px;
			height: 60px;
			position: absolute;
			bottom: 80px;
			display: flex;
			justify-content: space-between;
		}
		.information_phone {
			width: 400px;
			height: 76px;
			border-top: 1px solid #e1e1e1;
			position: absolute;
			bottom: 0px;
			display: flex;
			justify-content: space-around;
			background-color: #ffffff;
			// 拨号
			.phone_dial {
				min-width: 120px;
				height: 34px;
				border-radius: 3px;
				border: solid 1px #cccccc;
				margin-top: 23px;
				line-height: 34px;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				.phone_text {
					min-width: 105px;
					margin-left: 10px;
					margin-right: 10px;
					color: #666666;
				}
				.phone_icon {
					display: inline-block;
					width: 40px;
					height: 34px;
					background-color: #eeeeee;
					text-align: center;
					color: #209c1a;
				}
			}
			// 分机号
			.phone_extension {
				min-width: 120px;
				height: 34px;
				border-radius: 3px;
				border: solid 1px #cccccc;
				margin-top: 23px;
				line-height: 34px;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				.phone_text {
					min-width: 60px;
					margin-left: 10px;
					color: #666666;
				}
				.phone_icon {
					display: inline-block;
					width: 40px;
					height: 34px;
					background-color: #eeeeee;
					text-align: center;
					color: #a1a1a1;
				}
			}
			// 挂机
			.phone_hangUp {
				mixn-width: 120px;
				height: 34px;
				border-radius: 3px;
				border: solid 1px #e64322;
				margin-top: 23px;
				line-height: 34px;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				.phone_text {
					margin-left: 10px;
					margin-right: 10px;
					color: #666666;
				}
				.phone_icon {
					display: inline-block;
					width: 40px;
					height: 34px;
					background-color: #eeeeee;
					text-align: center;
					color: #e64322;
				}
			}
			// 不同分机号
			.phone_dialExtension {
				width: 120px;
				height: 34px;
				border-radius: 3px;
				border: solid 1px #0080ff;
				margin-top: 23px;
				line-height: 34px;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				.phone_text {
					margin-left: 10px;
					color: #666666;
				}
				.phone_icon {
					display: inline-block;
					width: 40px;
					height: 34px;
					background-color: #eeeeee;
					text-align: center;
					color: #0080ff;
				}
			}
		}
	}
}
</style>
